import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';
import { PageHeading } from '../components/Common';
import { WorkspaceStats, RecentConversations } from '../components/WorkspaceOverview';
import { IncomingPanel } from '../components/IncomingPanel';
import { SourcesPanel } from '../components/SourcesPanel';
import { DemoDraft } from '../components/demo/DemoDraft';
import { demoTickets, demoStats } from '../lib/demo';
import { GoogleSignInButton } from '../auth/AuthControls';

const readOnly = () => undefined;
export default function PublicWorkspace() {
  const {id} = useParams();
  const ticket = id ? demoTickets.find(value => value.id === id) : demoTickets[0];
  if (!ticket) return <section className="auth-failure" data-testid="private-ticket-notice"><LockKeyhole size={30}/><h1 data-testid="private-ticket-title">This conversation is private.</h1><p data-testid="private-ticket-description">Only approved team accounts can open real customer conversations.</p><GoogleSignInButton testId="private-ticket-sign-in"/><Link to="/" data-testid="private-ticket-back">View the public demo</Link></section>;
  return <div className="workspace-page page-enter">
    <PageHeading eyebrow="A LITTLE ORDER. A LOT MORE CARE." title="Triage workspace" subtitle="Read-only examples · No real customer data"/>
    <WorkspaceStats stats={demoStats}/>
    <div className="workbench public-workbench" data-testid="public-demo-workspace">
      <IncomingPanel ticket={ticket} message={ticket.message} title={ticket.title} channel={ticket.channel} tone={ticket.tone} busy={false} stage="" setMessage={readOnly} setTitle={readOnly} setChannel={readOnly} setTone={readOnly} onGenerate={readOnly} onSample={readOnly}/>
      <DemoDraft ticket={ticket}/>
      <SourcesPanel ticket={ticket} articles={demoStats.articles}/>
    </div>
    <RecentConversations tickets={demoTickets} total={demoTickets.length}/>
  </div>;
}